import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import {getStorage} from 'firebase/storage';
import { getAuth } from "firebase/auth";

const firebaseConfig = {
    apiKey: "AIzaSyBfVidsaCRheYIXdiOBDEbQLr9mh7XAW28",
    authDomain: "grupo3-r3act.firebaseapp.com",
    projectId: "grupo3-r3act",
    storageBucket: "grupo3-r3act.appspot.com",
    messagingSenderId: "755368223035",
    appId: "1:755368223035:web:6d29d92a70b5e9f78b171e"
};

const app = initializeApp(firebaseConfig);

export const db = getFirestore(app);
export const storage = getStorage(app);
// Initialize Firebase Authentication and get a reference to the service
export const auth = getAuth(app);